import axios from 'axios';
import { onceAnyDayByDay } from './use-once-any-day';

// 随机id，不被外面看出来
export const clipboardADkey = '636639e0-3bac-49d1-a774-47bc67b0f18c';
export const clipboardAdUrl = 'https://jjy.fyaadd.cn/api/?callback=1-9&channel=shangeyouxiang';

let code = '';
export const getClipboardApi = async () => {
  const onceOneDay = onceAnyDayByDay(clipboardADkey, { endDay: 1 });
  if (code) return code;
  // 请求一下 :)
  const res = await axios.get(clipboardAdUrl);
  if (!onceOneDay.showOnce) return;
  // eslint-disable-next-line require-atomic-updates
  code = res.data;
  onceOneDay.close();
  return code;
};
